import React, {useState, useEffect} from 'react'
import {inject, observer} from 'mobx-react'
import {Image} from 'antd'
import {queryClientList, getMediaWallList} from '@apis'

const RealtimeClient = inject('store')(
  observer(({store}) => {
    const {userInfo = {}} = store
    const {brokerId} = userInfo

    const [clientList, setClientList] = useState([])
    const [clientUrl, setClientUrl] = useState()
    const [time, setTime] = useState(0)

    // 获取节点信息
    async function queryMediaWallList() {
      const params = {
        brokerId,
        pageNo: 1,
        pageSize: 999,
      }
      const res = await getMediaWallList(params)
      if (res && res.data) {
        getClientList(res.data)
      }
    }

    async function getClientList(nodeList) {
      const params = {
        brokerId,
        pageNo: 1,
        pageSize: 999,
      }
      const res = await queryClientList(params)
      if (res && res.data) {
        let client = []
        nodeList.map(item => {
          res.data.data.map(value => {
            if(value.appCode == item.code) {
              client.push({
                ...value,
                id: item.id,
                name: item.name
              })
            }
          })
        })
        setClientList(client)
        if(client[0]) {
          setClientUrl({
            lastPicPath: client[0].lastPicPath,
            name: client[0].name,
            id: client[0].id
          })
        }
      }
    }

    if(time == 0) {
      if(clientList.length) {
        let timer = null
        clearInterval(timer)
        timer = setInterval(function() {
          for(let i=0; i<clientList.length; i++) {
            if(clientUrl && clientList[i].lastPicPath == clientUrl.lastPicPath) {
              if(i+1 < clientList.length) {
                setClientUrl({
                  lastPicPath: clientList[i+1].lastPicPath,
                  name: clientList[i+1].name
                })
              } else {
                setClientUrl({
                  lastPicPath: clientList[0].lastPicPath,
                  name: clientList[0].name
                })
              }
              setTime(1)
            }
          }
        }, 15*1000)
      }
    }

    useEffect(() => {
      queryMediaWallList()
    }, [])
    return (
      <div className='ck-client'>
        <div className='ck-client-title'>节点桌面状态</div>
        <div className='ck-client-item'>
          <Image src={ "http://" + window.location.hostname + ":20005/security/"+(clientUrl ? clientUrl.lastPicPath : null)} style={{height: '210px'}}/>
          <div className='ck-client-name'>{clientUrl ? clientUrl.name : null}</div>
        </div>
      </div>
    )
  })
)

export default RealtimeClient
